import {
  useCartQuery,
} from '@graphcommerce/magento-cart'
import { CartPageDocument } from "@graphcommerce/magento-cart-checkout";
import { Hidden } from '@mui/material';
import { useContext } from 'react'
import { ModalContext } from '../../../context/context';
import IconCart3 from "../../icons/IconCart3";
// eslint-disable-next-line import/no-cycle
import CartPage from "../../showCart";


// eslint-disable-next-line import/no-default-export
export default function CartIcon() {
  const useModal = useContext(ModalContext);
  const cart = useCartQuery(CartPageDocument, { returnPartialData: true, errorPolicy: 'all' })
  const { data } = cart

  return (
    <>
      <Hidden mdDown>

        <div className="flex flex-row align-middle items-center justify-around w-[130px]  h-[40px] bg-primary-500 rounded-md p-[5px] text-sm text-white cursor-pointer"
          onClick={() => useModal.set && useModal.set({ title: 'سبد خرید', content: <CartPage />, open: true, position: 'right' })} >


          <IconCart3 width={30} height={30} />
          سبد خرید
          <div className='w-[0.5px] h-[20px] bg-[#55555a]  ' />

          <span className="flex items-center justify-center text-lg min-w-4   font-bold h-full ">{data?.cart?.items?.length}</span>

        </div>
      </Hidden>
      <Hidden mdUp>
        <div className="relative bg-light-170 rounded-md p-1" onClick={() => useModal.set && useModal.set({ title: 'سبد خرید', content: <CartPage />, open: true, position: 'right' })}>
          <IconCart3 width={28} height={28} className="text-black cursor-pointer" />
          {

            data?.cart?.items?.length && <span className="absolute text-sm leading-[1.2] w-4 h-4 text-center -top-2 -right-2 bg-secondary-500 rounded-full text-light-100">{data?.cart?.items?.length}</span>
          }
        </div>
      </Hidden>
    </>
  )
}